import React from "react";

function QuestionStep(props) {
  const showQuestions = () => {
    if (!props.section.header) {
      return true;
    }

    return props.values[props.section.header.name] === "true";
  };

  const show = showQuestions();

  return (
    <div className="vetting-step">
      <section className="vetting-section">
        <h1 className="vetting-title">{props.section.title}</h1>

        <div className="vetting-question-list">
          {props.section?.header && props.section.header.display !== "false" && (
            <div className="vetting-question-row" key={props.section.header.question}>
              <div className="vetting-radio-group" onChange={props.onFormFieldChange}>
                <label className="vetting-radio-option">
                  <input
                    className="form-check-input"
                    type="radio"
                    name={props.section.header.name}
                    reason={props.section.header.reason}
                    value={true}
                    required
                    defaultChecked={props.values[props.section.header.name] === "true"}
                  />
                  <span>Yes</span>
                </label>

                <label className="vetting-radio-option">
                  <input
                    className="form-check-input"
                    type="radio"
                    name={props.section.header.name}
                    reason={props.section.header.reason}
                    value={false}
                    required
                    defaultChecked={props.values[props.section.header.name] === "false"}
                  />
                  <span>No</span>
                </label>
              </div>

              <div className="vetting-question-text">
                {props.section.header.question}
                {props.section.header.extras && (
                  <div className="vetting-question-extra">{props.section.header.extras}</div>
                )}
              </div>
            </div>
          )}

          {props.section.questionArray.map((item) => {
            const shouldShow = item.matchWithHeader
              ? item.matchWithHeader === "true"
                ? props.values[props.section.header.name] === "true"
                : props.values[props.section.header.name] === "false"
              : show;

            if (!shouldShow) {
              return null;
            }

            return (
              <div
                key={item.question}
                className={`vetting-question-row ${
  props.section?.header || item.needPad || item.matchWithHeader
    ? "vetting-question-row-indented"
    : ""
}`}
              >
                <div className="vetting-radio-group" onChange={props.onFormFieldChange}>
                  <label className="vetting-radio-option">
                    <input
                      className="form-check-input"
                      type="radio"
                      name={item.name}
                      reason={item.reason}
                      value={true}
                      required
                      defaultChecked={props.values[item.name] === "true"}
                    />
                    <span>Yes</span>
                  </label>

                  <label className="vetting-radio-option">
                    <input
                      className="form-check-input"
                      type="radio"
                      name={item.name}
                      reason={item.reason}
                      value={false}
                      defaultChecked={props.values[item.name] === "false"}
                    />
                    <span>No</span>
                  </label>
                </div>

                <div className="vetting-question-text">
                  {item.question}
                  {item.extras && <div className="vetting-question-extra">{item.extras}</div>}
                </div>
              </div>
            );
          })}

          <div className="vetting-button-row">
            <button className="btn btn-warning pe-4 ps-3" onClick={props.flipBack}>
              Back
            </button>

            {props.flipper.currentStep !== 7 && (
              <button className="btn btn-success" onClick={props.flipForward}>
                Forward
              </button>
            )}

            {props.flipper.currentStep === 7 && (
              <button className="btn btn-primary" onClick={props.submitForm}>
                Submit
              </button>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default QuestionStep;
